import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../../shared';
import { ConfigPedidoModule } from '../../../../configuracoes/app/pedido';
import { PedidoNaoLiberadoCardInfoBonificacaoExcedenteModule } from '../card-info-bonificacao-excedente';
import { PedidoNaoLiberadoCardInfoDescontosMaximosItensExcedidosModule } from '../card-info-descontos-maximos-itens-excedidos';
import { PedidoNaoLiberadoCardInfoLucroLiquidoAbaixoModule } from '../card-info-lucro-liquido-abaixo';
import { PedidoNaoLiberadoCardInfoClienteInadimplenteModule } from '../card-info-cliente-inadimplente/pedido-nao-liberado-card-info-cliente-inadimplente.module';
import { PedidoNaoLiberadoCardInfoLimiteCreditoExcedidoModule } from '../card-info-limite-credito-excedido/pedido-nao-liberado-card-info-limite-credito-excedido.module';

import { PedidoNaoLiberadoCardInfoComponent } from './pedido-nao-liberado-card-info.component';

@NgModule({
    imports: [
        SharedModule,
        ConfigPedidoModule,
        PedidoNaoLiberadoCardInfoBonificacaoExcedenteModule,
        PedidoNaoLiberadoCardInfoDescontosMaximosItensExcedidosModule,
        PedidoNaoLiberadoCardInfoLucroLiquidoAbaixoModule,
        PedidoNaoLiberadoCardInfoClienteInadimplenteModule,
        PedidoNaoLiberadoCardInfoLimiteCreditoExcedidoModule
    ],
    declarations: [
        PedidoNaoLiberadoCardInfoComponent
    ],
    exports: [
        PedidoNaoLiberadoCardInfoComponent
    ]
})
export class PedidoNaoLiberadoCardInfoModule { }
